import Api from "./Api";

export const centralServerService = Api;
export type {
    BillingDetailsCollectionPolicy,
    PaymentTerminalBillingDetails,
    PaymentTerminalBillingDetailsSessionData,
    PaymentTerminalBillingDetailsTaxIdLookupData,
} from './Api';
